






import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const AppStore = namespace("App");

@Component
export default class BaseView extends Vue {
  @AppStore.State
  public reportYear!: number;
}
